// Contact
export const sendContactForm = async (values: {
  collaborateurId: string,
  message: string,
  contact: {
    email: string,
    prenom: string,
    nom: string,
    telephone: string
  },
  consent: {
    privacyConsentGiven: boolean,
    consentText: string,
    privacyConsentAt: string,
    consentLanguage: string,
    privacyPolicyUrl: string,
    privacyPolicyVersion: string
  }
}) => {

  const url =
    `${process.env.NEXT_PUBLIC_API_URL}/diffusions/form/contact/collaborateur`
  const options = {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "accept": "application/json"
    },
    // body: JSON.stringify({...values, contact: {...values.contact, telephone: '08'}}),
    body: JSON.stringify(values),
  };

  const response = await fetch(url, options);

  if (!response.ok) {
    throw new Error(`API error ${response.status}`)
  }

  return await response.json()
}

// Contact
export const sendAskInfosForm = async (values: {
  venteReferenceUnique: string,
  message: string,
  contact: {
    email: string,
    prenom: string,
    nom: string,
    telephone: string
    },
  consent: {
    privacyConsentGiven: boolean,
    consentText: string,
    privacyConsentAt: string,
    consentLanguage: string,
    privacyPolicyUrl: string,
    privacyPolicyVersion: string
  }
}) => {

  const url =
    `${process.env.NEXT_PUBLIC_API_URL}/diffusions/form/contact/vente`
  const options = {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "accept": "application/json"
    },
    // body: JSON.stringify({...values, contact: {...values.contact, telephone: '08'}}),
    body: JSON.stringify(values),
  };

  const response = await fetch(url, options);

  if (!response.ok) {
    throw new Error(`API error ${response.status}`)
  }

  return await response.json()
}

// Estim Form
export const sendEstimForm = async (values: {
  message: string,
  agenceId: string,
  vente: {
    statut: null,
    motif: null,
    variant: string,
    adressePostale: string,
    ville: string,
    codePostal: string,
    codeInsee: string,
    type: string,
    nbPieces: number,
    surface: number,
    latitude: number,
    longitude: number,
  },
  contact: {
    email: string,
    prenom: string,
    nom: string,
    telephone: string
  },
  consent: {
    privacyConsentGiven: boolean,
    privacyConsentAt: string,
    privacyPolicyVersion: string,
    privacyPolicyUrl: string,
    consentText: string,
    consentLanguage: string
  }
}) => {

  const url =
    `${process.env.NEXT_PUBLIC_API_URL}/diffusions/form/estimation`
  const options = {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "accept": "application/json"
    },
    // body: JSON.stringify({
    //   ...values,
    //   contact: {
    //     ...values.contact,
    //     email: 'csdsq',
    //     telephone: '08'
    //   }}),
    body: JSON.stringify(values),
  };

  const response = await fetch(url, options);
  if (!response.ok) {
    throw new Error(`API error ${response.status}`)
  }

  return await response.json()
}

// Discovery
export const sendDiscoveryForm = async (values: {
    agenceId: string,
    withVente: boolean,
    achat: {
      variant: "achatvente" | "location",
      secteurs: {
        ville: string,
        codePostal: string,
        codeInsee: string,
      }[],
      bienTypes: string[],
      surfaceHabitable: number,
      surfaceHabitableMax: number,
      surfaceTerrain: number,
      surfaceTerrainMax: number,
      chambresCount: number,
      salleDeBainMin: number,
      wcMin: number,
      piscineMin: number,
      parkingMin: number,
      garageMin: number,
      terrasseMin: number,
      chauffageEnergies: (
        'Aérothermie' |
        'Bois' |
        'Bois en Granulés' |
        'Électricité' |
        'Fioul' |
        'Gaz citerne' |
        'Gaz de ville' |
        'Géothermie' |
        'Autre'
      )[],
      chauffageMecanismes: (
        'Au plafond' |
        'Au sol' |
        'Chaudière à granulés' |
        'Chaudière fioul' |
        'Chaudière gaz' |
        'Cheminée foyer fermé' |
        'Cheminée ouverte' |
        'Climatisation réversible' |
        'Panneau photovoltaïque' |
        'Panneau solaire' |
        'Poêle à granulés' |
        'Poêle de masse' |
        'Poêle traditionnel' |
        'Pompe à chaleur' |
        'Radiant' |
        'Radiateur' |
        'Radiateurs électriques à inertie' |
        'Sèche serviette' |
        'Soufflant' |
        'Autre'
      )[],
      classeEnergetiques: string[],
      budgetMin: number,
      budgetMax: number,
      budgetCommentaire: string,
      demarchesBancaires: string,
      adultsCount: number,
      childrenCount: number,
      childrenSchools: string[],
      commentaire: string,
      criteres:
        {
          label: string,
          type: 'souhaite' | 'redhibitoire',
        }[],
      criteresIds: []
    },
    vente: {
      variant: string,
      adressePostale: string,
      ville: string,
      codePostal: string,
      codeInsee: string,
      type: string,
      statut: null,
      latitude: number,
      longitude: number,
      nbPieces: number,
      surface: number,
      motif: null,
      commentaire: string,
    } | null,
    contact: {
      email: string,
      prenom: string,
      nom: string,
      telephone: string,
      civilite: string,
      adressePostale: string | null,
      codePostal: string,
      ville: string,
      profession: string,
      professionVille: string,
      professionCodePostal: string,
    },
    consent: {
      privacyConsentGiven: boolean,
      privacyConsentAt: string,
      privacyPolicyVersion: string,
      privacyPolicyUrl: string,
      consentText: string,
      consentLanguage: string,
    }
  }) => {

  const url =
    `${process.env.NEXT_PUBLIC_API_URL}/diffusions/form/decouverte`
  const options = {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "accept": "application/json"
    },
    // body: JSON.stringify({...values, contact: {...values.contact, telephone: '08'}}),
    body: JSON.stringify(values),
  };

  const response = await fetch(url, options);
  if (!response.ok) {
    throw new Error(`API error ${response.status}`)
  }

  return await response.json()
}
